
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Dispositivo } from "app/models/dispositivo.model";
import { Observable } from "rxjs";

export abstract class AbDispositivoSip extends AppService {

  abstract prefixo: string;
  abstract salvar(dispositivo: Dispositivo): Observable<any>;
  abstract getAllDispositivos(filter: AppFilter): Observable<any>;
  abstract desativar(id: number);
  abstract getById(id: number): Observable<any>;
  abstract getConfigSIP(): Observable<any>;
  abstract getControleChamadaStatus(): Observable<{ controleChamadaAtivo: boolean }>;
  abstract getSipRegistrationStatus(): Observable<{ sipRegistrationStatusAtivo: boolean }>;
}